import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {HttpClientService} from '../http-client/http-client.service';
import {EnvironmentService} from '../environment/environment.service';
import {UserContextResultDto} from './user-context-result-dto';
import {HttpResponse} from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class UserContextService {
  constructor(private readonly httpClientService: HttpClientService,
              private readonly environmentService: EnvironmentService) {
  }

  private readonly contextApiCallResources = this.environmentService.beContextApiUrl + 'contexts';

  getUserContext(): Observable<'CHANCERY' | 'CLIENT'> {
    return this.httpClientService.get<UserContextResultDto>(this.contextApiCallResources)
      .pipe(
        map((response: HttpResponse<UserContextResultDto>) => {
          let hasChanceryContext = 0;
          if (null === response || null === response.body) {
            return 'CHANCERY';
          }
          const contextData = response.body;
          if (null !== contextData) {
            contextData.forEach(hit=> {
              if ((null !== hit.realm) && hit.realm.toUpperCase().includes('CHANCERY')) {
                hasChanceryContext++;
              }
            });
          }

          return hasChanceryContext > 0 ? 'CHANCERY' : 'CLIENT';
        })
    );
  }

}
